export const careers = [
    {
        id:1,
        link:'/engineering',
        subject:'Engineering',
        startGrad:'from-[#007adf]',
        endGrad:'to-[#00ecbc]',
        content:'It is the application of science and mathematics to solve problems. Engineers figure out how things work and find practical uses for scientific discoveries.'
    },
    {
        id:2,
        link:'/medical',
        subject:'Medical',
        startGrad:'from-[#ee0979]',
        endGrad:'to-[#ff6a00]',
        content:'This is the study and research of medicines and the human internal body. Students who aim to become doctors apply for medical fields.'
    },
    {
        id:3,
        link:'/management',
        subject:'Management',
        startGrad:'from-[#20e2d7]',
        endGrad:'to-[#f9fea5]',
        content:'It is a versatile subject that teaches students how to understand organizational behavior, motivate and influence others, as well as become a leader in the modern business world.'
    },
    {
        id:4,
        link:'/law',
        subject:'Law',
        startGrad:'from-[#ee0a67]',
        endGrad:'to-[#fea1be]',
        content:'Scope of law as a career is immense in India as opportunities expand in corporate houses, law firms, law agencies, administrative services, and the likes.'
    },
    {
        id:5,
        link:'/humanities',
        subject:'Humanities',
        startGrad:'from-[#6da1fc]',
        endGrad:'to-[#4cd9fe]',
        content:'The humanities include the study of ancient and modern languages, literature, philosophy, history, archaeology, anthropology, human geography, law, religion, and art.'
    },
    {
        id:6,
        link:'/others',
        subject:'Others',
        startGrad:'from-pink-500',
        endGrad:'to-orange-400',
        content:'Although many new subjects and technologies exist, not everyone is aware of them. Study these unexplored courses and advance your profession to a new brightpath'
    },
]

export const engineeringOpt = [
    {
        id:1,
        link:'/engineering',
        subject:'Branches',
        startGrad:'from-[#11998e]',
        endGrad:'to-[#38ef7d]',
        content:'Engineering is classified into diverse streams according to the core work of research and practicality.        '
    },
    {
        id:2,
        link:'/skills',
        subject:'Skills',
        startGrad:'from-[#0082c8]',
        endGrad:'to-[#0082c8]',
        content:'These days, skills are more important than degrees. Learn about these different skills and excel your future.'
    },
    {
        id:3,
        link:'/job',
        subject:'Jobs',
        startGrad:'from-[#06beb6]',
        endGrad:'to-[#48b1bf]',
        content:'There are many jobs other than academic studies which have a high scope in future.        '
    },
    {
        id:4,
        link:'/exams',
        subject:'Exams',
        startGrad:'from-[#36D1DC]',
        endGrad:'to-[#5B86E5]',
        content:'The competitive exams help you to provide admission for further studies in prestigious institutions of our country.        '
    },
]